import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

export const GetGoogleTagManagerID = () => {
  const { NODE_ENV } = publicRuntimeConfig
  if (NODE_ENV === 'production') {
    return 'GTM-TQCQPJ3'
  } else if (NODE_ENV === 'staging') {
    return 'GTM-PVS2SF8'
  }
  return 'GTM-PVS2SF8'
}
